import * as http from '@/util/http'
import { z } from 'zod'

export const IndustrySchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.url().optional(),
  established_date: z.date().optional(),
  capital: z.number().int().optional(),
  employee_count: z.number().int().optional(),
  isActive: z.boolean(),
  imageUrl: z.url().optional(),
  summary: z.array(z.string()).optional(),
  intro: z.any().optional(),
  industries: z.array(IndustrySchema),
  bookmarked: z.boolean(),
})

export type Company = z.input<typeof CompanySchema>

export type CompanyFilter = {
  pageNo?: number
  pageSize?: number
  bookmarked?: boolean
  industryCategoryId?: number
}

export function buildSearchParams(filter: CompanyFilter) {
  return new URLSearchParams(
    Object.entries(filter)
      .filter(([_, value]) => value !== undefined && value !== null && value !== false)
      .map(([key, value]) => [key, String(value)])
  )
}

export async function fetchCompanies(filter: CompanyFilter): Promise<Company[]> {
  const { data } = await http.get<Company[]>('/api/v1/company', { queryParams: filter })
  return data
}

export type BookmarkAction = 'ADD' | 'REMOVE'

export type SetBookmarkPayload = {
  companyId: number
  action: BookmarkAction
}

export async function setBookmark({ companyId, action }: SetBookmarkPayload) {
  if (companyId) return http.put(`/api/v1/company/${companyId}/bookmark`, { payload: { action } })
}

export type ActivenessPayload = {
  id: number
  isActive: boolean
}

export async function setActive(payload: ActivenessPayload) {
  return http.put('/api/v1/company', { payload })
}

export const PermSchema = z.object({
  canCreate: z.boolean(),
  canWrite: z.boolean(),
  canDelete: z.boolean(),
  canGlobalAccess: z.boolean(),
  canReadInactive: z.boolean(),
})

export type Perm = z.infer<typeof PermSchema>

export async function getPerm(): Promise<Perm> {
  const { data } = await http.get<Perm>(`/api/v1/company/perm`)
  return data
}
